import { MESSAGE } from "./message.utils";

let _currentMessages: any = MESSAGE;

export function setCurrentMessages(messages: any) {
  _currentMessages = messages;
}

export class TranslateUtils {
  static argsKey = "#";

  static translate(value: string, args?: any): string {
    if (!value) {
      return "";
    }
    const splitMessage: string[] = value.split(".");

    let message = this.readMessage(splitMessage, 0, _currentMessages);

    if (!message) {
      return value;
    }

    if (args) {
      const keys = Object.keys(args);
      for (const key of keys) {
        message = message.replaceAll(`${this.argsKey}${key}`, args[key]);
      }
    }
    return message;
  }

  static translatePlural(val: string, nb: number, args?: any): string {
    const value = val;
    if (nb <= 1) {
      return this.translate(value, args);
    } else {
      return this.translate(`${value}_plural`, args);
    }
  }

  /**
   * need to return MESSAGE[params[0]][params[1]] ...
   * @param {string[]} params
   * @param {number} index
   * @param response
   * @return {any}
   */
  static readMessage(params: string[], index: number, response) {
    if (params.length === index) {
      return response;
    }

    const message = response[params[index]];
    if (!message) {
      return message;
    }

    return this.readMessage(params, index + 1, message);
  }
}
